document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cases__showMore-button').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.cases__item');
      const textElements = item.querySelectorAll('.cases__text');

      const isCollapsed = Array.from(textElements).some(textElement =>
        textElement.classList.contains('cases__text--collapsed')
      );

      if (isCollapsed) {
        textElements.forEach(textElement => {
          textElement.classList.remove('cases__text--collapsed');
          textElement.classList.add('cases__text--expanded');
        });

        button.textContent = 'Show Less';
      } else {
        textElements.forEach(textElement => {
          textElement.classList.remove('cases__text--expanded');
          textElement.classList.add('cases__text--collapsed');
        });

        button.textContent = 'Show More';
      }
    });
  });
});
